import {useEffect} from 'react'
import {TreeDocument, useTreeDoc} from '@/components/TreeDoc/index.mjs'
import {subscribeOnce} from '@/script/event.mjs'
import defaultHotkeys from './hotkeys.mjs'
import Canvas from './Canvas.jsx'
import Children from './Children.jsx'
import Node from './Node.jsx'
import NodeContent from './NodeContent.jsx'
import NodeInnerBox from './NodeInnerBox.jsx'
import NodeOuterBox from './NodeOuterBox.jsx'
import NodeText from './NodeText.jsx'
import Tree from './Tree.jsx'
import TreeJoint from './TreeJoint.jsx'

const MindMap = ({
    children,
    components,
    Doc,
    hotkeys,
    initData,
    plugins,
    onLoad,
    ...props
}) => {
    const map = useTreeDoc({Doc, initData, plugins})

    map.components = {
        Canvas,
        Children,
        Node,
        NodeContent,
        NodeInnerBox,
        NodeOuterBox,
        NodeText,
        Tree,
        TreeJoint,
        ...components,
    },

    useEffect(
        () => {
            const handleLoad = () => {
                onLoad?.(map)
            }

            subscribeOnce(map, 'load', handleLoad)
        },

        []
    )

    map.useRegisterHotkeys({...defaultHotkeys, ...hotkeys})

    return (
        <TreeDocument
            doc={map}
            {...props}
        >
            {children}
        </TreeDocument>
    )
}

export default function MindMapWrapper(props) {
    if (! props.initData) {
        return null
    }

    return <MindMap {...props} />
}
